import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import DropdownOption from "components/Common/DropdownOption";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import { AI_MODEL_NEWS_STOCK_OPTIONS, SYSTEM_CONFIG_KEY } from "helpers/constans";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Container, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { getConfiguration, postGenerateNewsStockByToss } from "store/thunks";
import * as Yup from "yup";

export interface Props {
    isOpen: boolean;
    params: any;
    onRefresh?: () => void,
    onClose?: () => void,
}

registerLocale("en", en);
registerLocale("ko", ko);

const ModalGenerateNewStock = ({
    isOpen,
    params = {},
    onRefresh,
    onClose,
}: Props) => {
    const { t, i18n } = useTranslation();

    const AI_MODEL_NEWS_STOCK_OPTIONS_LANG: any = AI_MODEL_NEWS_STOCK_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleSubmit = async (values: any) => {
        try {
            setIsLoading((_prev) => true);
            const data: any = {
                ...params,
                ai_model: values?.ai_model?.value || AI_MODEL_NEWS_STOCK_OPTIONS_LANG[0]?.value,
            };
            const response: any = await postGenerateNewsStockByToss(data);
            setIsLoading((_prev) => false);
            if (response?.code === 200) {
                toast(
                    `${t("The process has been completed.")}`,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                onRefresh && onRefresh();
            } else {
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        ai_model: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).nullable().required(`${t("AI Model is required")}`),
    });

    const formik = useFormik({
        initialValues: {
            ai_model: AI_MODEL_NEWS_STOCK_OPTIONS_LANG[0],
        },
        validationSchema,
        onSubmit: handleSubmit,
    });

    const handleClose = () => {
        formik.resetForm();
        formik.setErrors({});
        onClose && onClose();
    }

    const handleGetConfig = async () => {
        try {
            const response: any = await getConfiguration();
            if (response?.code === 200) {
                const _configs = response?.data?.list || [];
                const _ai_model = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.STOCK_TOSS_NEWS_GENERATE_AI_MODEL) || AI_MODEL_NEWS_STOCK_OPTIONS_LANG[0];
                formik?.setFieldValue('ai_model', _ai_model);
            }
        } catch (error) {
            return error;
        }
    };

    useEffect(() => {
        if (isOpen) {
            handleGetConfig();
        }
    }, [isOpen]);

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="sm"
                scrollable={false}
            >
                <ModalHeader toggle={handleClose}>
                    <>{t("Button Generate News")}</>
                </ModalHeader>
                <ModalBody className="pt-2">
                    <Container>
                        <Row>
                            <form onSubmit={formik.handleSubmit}>
                                <div style={{ maxWidth: '500px', margin: '0 auto' }}>
                                    <Row>
                                        <Col sm={12} md={12} xl={12} className='mt-2 px-0'>
                                            <Label htmlFor="formSizeDefault" className="form-label">{t('AI Model')}<span className="text-danger"> *</span></Label>
                                            <DropdownOption
                                                name="ai_model"
                                                dataList={AI_MODEL_NEWS_STOCK_OPTIONS_LANG || []}
                                                placeholder={`${t("AI Model")}...`}
                                                className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                                classNamePrefix="name-prefix"
                                                initialValue={formik?.values?.ai_model}
                                                onChangeSelect={(e: any) => {
                                                    formik?.setFieldValue('ai_model', e)
                                                }}
                                            />
                                        </Col>

                                        <Col sm={12} md={12} xl={12} className='mt-3 pt-1 text-end px-0'>
                                            <button
                                                style={{ width: '160px' }}
                                                type="submit"
                                                disabled={isLoading}
                                                className="btn btn-primary fs-14 rounded-pill">
                                                {isLoading ? <Spinner size="sm me-1" ></Spinner> : <></>}
                                                {t('Button Generate')}
                                            </button>
                                        </Col>
                                    </Row>
                                </div>
                            </form>
                        </Row >
                    </Container >
                </ModalBody>
            </Modal>
        </React.Fragment >
    );
};

export default ModalGenerateNewStock;
